import { PROFILE, EXPERIENCE } from "@/data/portfolio";

export const DA = {
  cover: {
    label: "Ansøgning · Customer Insights & Growth Researcher, Digital Product Development",
    role: "Customer Insights & Growth Researcher",
    attn: "Bixter · Att. Azadeh Sabouri, Digital Product Development",
    heading: "Jeres næste ejer af kundeindsigten.",
    dear: "Kære Azadeh,",
    paragraphs: [
      "I søger en ejer af kundeindsigten, der kan bygge research-systemet fra bunden med AI og omsætte løbende data fra målgruppen til vækst. Det har jeg bygget, to gange: én gang i en global robotvirksomhed, én gang med mine egne hænder.",
      "Hos Universal Robots drev jeg global discovery research for at definere kundebehov, pain points og muligheder i Asien, Europa og USA; byggede customer journey maps, arketyper og krav til forskellige målgrupper; validerede antagelser og testede idéer sammen med UX-arkitekten og designerne; og benchmarkede vores værditilbud mod de vigtigste konkurrenter i en model, vores CEO brugte til strategi.",
      "I Tennis Club Odense satte jeg analytics op i et digitalt produkt til løbende forbedring, mødte kunderne både fysisk og online, byggede community og feedback-loop og kørte betaen: udsolgt, NPS +66, rækkevidde +1.186 %.",
      "Jeres digitalisering er datadrevet og iterativ. Det er min research også, hands-on med AI i hvert trin, mennesket i loopet. Giv mig et kvarter, og jeg viser, hvordan jeg ville sætte Bixters loop fra indsigt til vækst op de første 90 dage. Min portfolio, https://sinthunathan.com, måler sin egen funnel, så I er i dataene, før vi mødes.",
    ],
    proof: [
      ["CEO-niveau", "benchmark af værditilbuddet brugt til strategi"],
      ["200+", "kundeinterviews · Asien, Europa, USA"],
      ["NPS +66", "research-system bygget fra bunden med AI"],
    ],
    regards: "Med venlig hilsen",
    enclosed: "Vedlagt: CV · Portfolio",
    references: "Referencer: https://sinthunathan.com/#testimonials",
    locale: "da-DK",
  },
  cv: {
    kicker: "Curriculum vitae",
    role: "Customer Insights & Growth Researcher",
    languages: "Dansk (modersmål) · Engelsk (flydende) · Fransk (godt)",
    portfolio: "Portfolio: https://sinthunathan.com",
    blocks: ["Min erfaring", "Uddannelse", "Certificeringer", "Udvalgte resultater", "Mine leverancer", "Mine værktøjer", "Den indsigtsfulde influencer", "Sprog"],
    metrics: [
      { value: "200+", label: "Interviews på tre kontinenter, Universal Robots" },
      { value: "PM → CEO", label: "Power BI-konkurrentbenchmark taget i brug af ledelsen" },
      { value: "+66", label: "NPS på et growth loop bygget fra bunden med AI" },
      { value: "+1.186 %", label: "Organisk rækkevidde, udsolgt event, team 4 → 15" },
    ],
    quote: { text: "This is what outstanding researchers, analysts and strategists do!", who: "Piotr M. Klima · Pricing Director, Universal Robots · ordret" },
    profile: PROFILE.about,
    experience: EXPERIENCE.map((e) => e.body),
    strengthsNote: "Gallup CliftonStrengths 34 · Top 5",
    voluntary: "Frivillig",
    present: "nu",
    roles: { "Board Member": "Bestyrelsesmedlem", "UX Researcher": "UX Researcher", "Counter Manager": "Counter Manager" },
    months: { Aug: "aug.", May: "maj" },
    education: { "Digital Concept Development": "Digital Konceptudvikling", "All A grades": "Alle 12-taller", "Future Skills Talent Programme": "Future Skills Talent Programme", MMA: "Market & Management Anthropology (MMA)" },
    focus: "Denne sæson: eventledelse, leder af fundingudvalget, marketingstrategi, organisationsstruktur og procesoptimering.",
    outcomes: [
      "Benchmark af værditilbuddet (Power BI) taget i brug fra PM til CEO.",
      "Global discovery, fabriksbesøg, 200+ interviews, 3 kontinenter, formede roadmappet.",
      "Training Partner-research: 'a tangible impact on our decision-making processes'.",
      "Research-system bygget fra bunden med AI: udsolgt, NPS +66, rækkevidde +1.186 %.",
    ],
    mentor: "mentor",
    colleague: "kollega",
    footer: "Interaktiv portfolio, cases og ordrette anbefalinger: https://sinthunathan.com",
    page: "CV · 1 / 1",
  },
};
